import { isAppStateReady } from '$appStore'
import { defer } from 'react-router-dom'

/**
 * Loader for the Create venue page. There is no data to preload - the page is
 * a form - but we gate on app-state readiness so a cold load (hard refresh)
 * doesn't fire API calls before the AngularJS bridge has set up auth and the
 * active-company context.
 */
export default async function loader() {
  await isAppStateReady()

  return defer({ data: Promise.resolve(true) })
}
